import React, { Component } from 'react';
import { Row, Col, Card, Container, Form, ButtonGroup, Button, Table } from 'react-bootstrap';
import * as Cookies from "es-cookie";
import './_exam_made_easy.scss';
import gql from "graphql-tag";
import { withApollo } from "react-apollo";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import { Link, withRouter } from 'react-router-dom';
import parse, { domToReact } from 'html-react-parser';
import { Scrollbars } from 'react-custom-scrollbars'

const renderThumb = ({ style, ...props }) => {
    const thumbStyle = {
        borderRadius: 6,
        width: '3px',
        backgroundColor: 'rgba(0, 0, 0, 0.1)'
    };
    return <div style={{ ...style, ...thumbStyle }} {...props} />;
};
class QuestionSelectedDetails extends Component {
    constructor(props) {
        super(props)

        this.state = {


        }
    }

    examTypeName = (value) => {
        let examTypeName = "";

        if (value == "1") {
            examTypeName = "NEET"
        } else if (value == "2") {
            examTypeName = "JEE"
        } else if (value == "3") {
            examTypeName = "AP-EAMCET-MPC";
        } else if (value == "6") {
            examTypeName = "TS-EAMCET-MPC"
        } else if (value == "7") {
            examTypeName = "AP-EAMCET-BiPC"
        } else if (value == "8") {
            examTypeName = "TS-EAMCET-BiPC"
        }

        return examTypeName;
    }

    render() {
        console.log("this.props.stateData.questionbank_checked", this.props.stateData)

        let array = [];
        let displayqustions = this.props.stateData.subjects.map((item) => {
            item.chapters.map((chdata) => {
                let object = { ...chdata }
                array.push(object);
            })
        })
        let chaptername = "Chapter";
        const chapter = this.props.stateData.subjects.map((item) => {
            if (item.subjectactive == "d-flex justify-content-between align-items-center active") {
                item.chapters.map((chdata) => {
                    if (chdata.chapteractive == "d-flex justify-content-between align-items-center active") {
                        chaptername = chdata.chapter;

                    }

                })
            }

        })
        console.log("array", array)
        return (
            <div className='exam_made_easy'>
                <Row>
                    <Col sm={12}>
                        <Table className="question_selection_details table-borderless">
                            <tbody>
                                <tr>
                                    <th>Exam Type </th>
                                    <th>: {this.props.stateData.exam_typeValue.label} </th>
                                </tr>
                                {this.props.stateData.exam_type != "" ? (
                                    <React.Fragment>
                                        {this.props.stateData.exam_type == "1" ? (
                                            <React.Fragment>
                                                {
                                                    this.props.stateData.pattern_type == "0" ? (
                                                        <React.Fragment>
                                                            <tr>
                                                                <th> Duration </th>
                                                                <th>: 180 Min </th>
                                                            </tr>
                                                            <tr>
                                                                <th>Total No Of Questions </th>
                                                                <th>: 180</th>
                                                            </tr>
                                                        </React.Fragment>
                                                    ) : this.props.stateData.pattern_type == "3" ? (
                                                        <React.Fragment>
                                                            <tr>
                                                                <th> Duration </th>
                                                                <th>: Custom </th>
                                                            </tr>
                                                            <tr>
                                                                <th>Total No Of Questions </th>
                                                                <th>: Custom</th>
                                                            </tr>
                                                        </React.Fragment>
                                                    ) : (

                                                        <React.Fragment>
                                                            <tr>
                                                                <th> Duration </th>
                                                                <th>: 180 Min </th>
                                                            </tr>
                                                            <tr>
                                                                <th>Total No Of Questions </th>
                                                                <th>: 200</th>
                                                            </tr>
                                                        </React.Fragment>
                                                    )
                                                }

                                            </React.Fragment>
                                        ) : this.props.stateData.exam_type == "3" || this.props.stateData.exam_type == "6" || this.props.stateData.exam_type == "7" || this.props.stateData.exam_type == "8" || this.props.stateData.exam_type == "9" || this.props.stateData.exam_type == "10" || this.props.stateData.exam_type == "11" ? (
                                            <React.Fragment>
                                                {
                                                    this.props.stateData.exam_generate_type ==  "group_custom"  ? (
                                                        <React.Fragment>
                                                        <tr>
                                                            <th> Duration </th>
                                                            <th>: Custom </th>
                                                        </tr>
                                                        <tr>
                                                            <th>Total No Of Questions </th>
                                                            <th>: Custom </th>
                                                        </tr>
                                                    </React.Fragment>
                                                    ):(
                                                        <React.Fragment>
                                                        <tr>
                                                            <th> Duration </th>
                                                            <th>: 180 min </th>
                                                        </tr>
                                                        <tr>
                                                            <th>Total No Of Questions </th>
                                                            <th>: 160</th>
                                                        </tr>
                                                    </React.Fragment>
                                                    )
                                                }
                                            </React.Fragment>
                                      
                                        ) : (

                                            <React.Fragment>
                                                {this.props.stateData.exam_type == "2" ? (
                                                    <React.Fragment>
                                                        {
                                                            this.props.stateData.pattern_type == "0" ?
                                                                (
                                                                    <React.Fragment>
                                                                        <tr>
                                                                            <th> Duration </th>
                                                                            <th>: 180 Min </th>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Total No Of Questions </th>
                                                                            <th>: 75</th>
                                                                        </tr>
                                                                        <tr>
                                                                            <th> General Questions </th>
                                                                            <th>: 20 Q</th>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Integer Questions </th>
                                                                            <th>: 5 Q</th>
                                                                        </tr>
                                                                    </React.Fragment>
                                                                ) : this.props.stateData.pattern_type == "3" ?
                                                                    (
                                                                        <React.Fragment>
                                                                            <tr>
                                                                                <th> Duration </th>
                                                                                <th>: Custom </th>
                                                                            </tr>
                                                                            <tr>
                                                                                <th>Total No Of Questions </th>
                                                                                <th>: Custom </th>
                                                                            </tr>
                                                                            <tr>
                                                                                <th> General Questions </th>
                                                                                <th>: Custom </th>
                                                                            </tr>
                                                                            <tr>
                                                                                <th>Integer Questions </th>
                                                                                <th>: Custom </th>
                                                                            </tr>
                                                                        </React.Fragment>
                                                                    ) : (
                                                                        <React.Fragment>
                                                                            <tr>
                                                                                <th> Duration </th>
                                                                                <th>: 180 Min </th>
                                                                            </tr>
                                                                            <tr>
                                                                                <th>Total No Of Questions </th>
                                                                                <th>: 90</th>
                                                                            </tr>
                                                                            <tr>
                                                                                <th>General Questions</th>
                                                                                <th>: 20 Q</th>
                                                                            </tr>
                                                                            <tr>
                                                                                <th>Integer Questions </th>
                                                                                <th>: 10 Q</th>
                                                                            </tr>
                                                                        </React.Fragment>

                                                                    )
                                                        }

                                                    </React.Fragment>) : (
                                                    <React.Fragment>
                                                        <tr>
                                                            <th> Duration </th>
                                                            <th>: 300 Min </th>
                                                        </tr>
                                                        <tr>
                                                            <th>No Of Questions </th>
                                                            <th>: 75</th>
                                                        </tr>
                                                    </React.Fragment>)}

                                            </React.Fragment>
                                        )}
                                    </React.Fragment>
                                ) : ("")}



                            </tbody>
                        </Table>
                    </Col>
                    <Col sm={12}>
                        <Scrollbars style={{ height: "40vh" }}
                            {...this.props}
                            renderThumbVertical={renderThumb}
                            autoHide
                            autoHideTimeout={500}
                            autoHideDuration={200}>
                            {this.props.stateData.subjects.map((subjectmapData) => (
                                <React.Fragment>{subjectmapData.checked == true ? (
                                    <Card className="border-0 bg-light">
                                        <Card.Header className="bg-secondary p-2">
                                            <Card.Title className="mb-0 text-white f-14">{subjectmapData.subject}</Card.Title>
                                        </Card.Header>
                                        <Card.Body className="p-1">
                                            <Scrollbars style={{ height: "80px" }}
                                                {...this.props}
                                                renderThumbVertical={renderThumb}
                                                autoHide
                                                autoHideTimeout={500}
                                                autoHideDuration={200}>
                                                {subjectmapData.chapters.map((chaptermapData) => {
                                                    let topiccount = "";
                                                    if (chaptermapData.checked == true) {
                                                        topiccount = chaptermapData.topics.filter((b) => b.checked == true)
                                                    }
                                                    return (
                                                        <React.Fragment>{chaptermapData.checked == true ? (
                                                            <Card className="single-list-card border-0 p-1">
                                                                <Card.Title className="f-14 text-center">{chaptermapData.chapter}-{topiccount.length}</Card.Title>
                                                                <ul className="list-unstyled topic-list bg-light m-0">
                                                                    {chaptermapData.topics.map((topicmapData) => (
                                                                        <React.Fragment>{topicmapData.checked == true ? (<li>{topicmapData.topic}</li>) : ("")}</React.Fragment>
                                                                    ))}
                                                                </ul>
                                                            </Card>) : ("")}</React.Fragment>
                                                    )
                                                })}
                                            </Scrollbars>
                                        </Card.Body>
                                    </Card>) : ("")}</React.Fragment>
                            ))}

                            {this.props.stateData.generate_type == "2" ? (
                                <React.Fragment>
                                    {this.props.stateData.questionbank_checked == true ? (
                                        <Card className="border-0 bg-light mb-2">
                                            <Card.Header className="bg-secondary">
                                                <Card.Title className="h6 mb-0 text-white">Added Questions</Card.Title>
                                            </Card.Header>
                                            <Card.Body className="p-3">
                                                <ul className="list-unstyled chapter-list bg-light m-0">
                                                    {array.map((chaptermapdata) => {
                                                        if (chaptermapdata.questionbarray.length > 0) {
                                                            return (<li>{chaptermapdata.chapter}-{chaptermapdata.questionbarray.length}</li>)
                                                        }
                                                    })}
                                                </ul>
                                            </Card.Body>
                                        </Card>
                                    ) : ("")}
                                </React.Fragment>
                            ) : ("")}

                        </Scrollbars>
                    </Col>
                </Row>

                <hr className='mt-0 mb-0' />
                <Row>
                    {
                        this.props.stateData.generate_type == "2" ?
                            (
                                <Col sm={12} className='mt-1'>
                                    <Button type="button" className="btn btn-light-blue center-auto" onClick={(e) => this.props.showQuestionGenerateModal(e, "draft")}>Save Draft</Button>
                                </Col>
                            )
                            :
                            ("")
                    }
                    <Col sm={12} className='mt-2'>
                        <Button type="button" className="btn btn-orange center-auto" onClick={(e) => this.props.showQuestionGenerateModal(e, "save")}>Generate </Button>
                    </Col>
                </Row>
            </div>

        )
    }
}


export default withRouter(withApollo((QuestionSelectedDetails)));


